import React from 'react';
import './Gift.scss';

class Gift extends React.Component {
  constructor(props) {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = async (event) => {
    event.preventDefault();
  }
  
  render() {
    return (
      <div className={"gift gift-"+this.props.index} onClick={this.handleClick}>
        <div className="inner"></div>
      </div>
    );
  }
}

export default Gift;
